import { gql, TypedDocumentNode } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import { CRM_TASK_FIELDS_FRAGMENT } from "@/fragments";
import type { PageInfo, PaginationVariables } from "@/components/Pagination";
import type { CRMTask, TaskStage } from "@/types";

export type TaskNode = CRMTask;

export type TasksQueryResponse = {
  tasks: {
    nodes: TaskNode[];
    pageInfo: PageInfo;
    totalCount: number;
  };
};

export type TasksInput = {
  search?: string;
  stage?: TaskStage[];
  authorId?: string;
  assignedToId?: string;
  unassigned?: boolean;
  myTasks?: boolean;
  assignedToDepartment?: string;
  authorDepartment?: string;
  teamTag?: string;
  dueDateRange?: { from?: string; to?: string };
  overdue?: boolean;
  dateRange?: { from?: string; to?: string };
  referenceableId?: string;
  referenceableType?: string[];
};

export type TaskOrderByInput = {
  field: string;
  direction: "ASC" | "DESC";
};

export type TasksQueryVariables = PaginationVariables & {
  input?: TasksInput;
  orderBy?: TaskOrderByInput;
};

export const TASKS_QUERY: TypedDocumentNode<TasksQueryResponse, TasksQueryVariables> = gql`
  query TasksQuery(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeCRMTasksInput
    $orderBy: BackofficeCRMTaskOrderByInput
  ) {
    tasks(first: $first, last: $last, before: $before, after: $after, input: $input, orderBy: $orderBy) {
      nodes {
        ...CRMTaskFields
        commentsCount
      }
      ...PageInfo
    }
  }
  ${CRM_TASK_FIELDS_FRAGMENT}
  ${PAGE_INFO_FRAGMENT}
`;
